import React from 'react';
import Icon from '../../../components/AppIcon';

const SupplierMap = ({ suppliers, language }) => {
  const countryCoordinates = {
    ethiopia: { lat: 9.145, lng: 40.489673 },
    kenya: { lat: -0.023559, lng: 37.906193 },
    uganda: { lat: 1.373333, lng: 32.290275 },
    nigeria: { lat: 9.081999, lng: 8.675277 }
  };

  const getMapCenter = () => {
    if (suppliers?.length === 0) return { lat: 5, lng: 35 };
    
    const firstSupplier = suppliers?.[0];
    const country = firstSupplier?.country_en?.toLowerCase();
    return countryCoordinates?.[country] || { lat: 5, lng: 35 };
  };

  const center = getMapCenter();

  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden">
      <div className="bg-primary/5 px-5 py-3 border-b border-border">
        <div className="flex items-center gap-2">
          <Icon name="Map" size={20} className="text-primary" />
          <h3 className="text-base font-heading font-semibold text-foreground">
            {language === 'en' ? 'Supplier Locations' : '供应商位置'}
          </h3>
        </div>
      </div>
      <div className="relative h-96 bg-muted">
        <iframe
          width="100%"
          height="100%"
          loading="lazy"
          title={language === 'en' ? 'Supplier Farm Locations' : '供应商农场位置'}
          referrerPolicy="no-referrer-when-downgrade"
          src={`https://www.google.com/maps?q=${center?.lat},${center?.lng}&z=5&output=embed`}
          className="border-0"
        />
        
        <div className="absolute bottom-4 left-4 bg-card/95 backdrop-blur-sm border border-border rounded-lg px-4 py-3 shadow-lg">
          <div className="flex items-center gap-2 mb-2">
            <Icon name="MapPin" size={16} className="text-primary" />
            <span className="text-sm font-medium text-foreground">
              {language === 'en' ? 'Active Suppliers' : '活跃供应商'}
            </span>
          </div>
          <div className="text-2xl font-heading font-bold text-primary">
            {suppliers?.length}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SupplierMap;